import styled from 'styled-components';
import { Color } from '../../../common/view/color/color';
import { CssFuncs } from '../../../foundation/css/css.funcs';

const Container = styled.div.withConfig({
  componentId: 'node-item-action-check_container',
  displayName: 'NodeItemActionCheck.Container',
})`
  ${CssFuncs.css.size({ xy: '18px' })}

  border-radius: 4px;
  border: 1.5px solid;

  box-sizing: border-box;

  ${CssFuncs.css.alignCenter()}

  user-select: none;
  cursor: pointer;

  transition:
    border-color 0.1s linear,
    background-color 0.1s linear,
    transform 0.1s linear;

  & {
    border-color: ${Color.alpha.white4};
    &:hover {
      border-color: ${Color.alpha.white6};
      background-color: ${Color.alpha.white1};
    }
  }

  &.checked {
    border-color: ${Color.alpha.white0};
    background-color: ${Color.alpha.white2};
    &:hover {
      border-color: ${Color.alpha.white0};
      background-color: ${Color.alpha.white3};
    }
  }

  &:hover {
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
  }
`;

const Icon = styled.div.withConfig({
  componentId: 'node-item-action-check_icon',
  displayName: 'NodeItemActionCheck.Icon',
})`
  color: ${Color.alpha.white4};
  ${Container}.not-checked & {
    opacity: 0;
  }

  ${Container}.checked & {
    opacity: 1;
  }
`;

export const NodeItemActionCheckStyle = {
  Container,
  Icon,
};
